import { useCallback, useRef } from 'react';

export function useDirtyFormGuard(onClose: () => void) {
  const dirtyRef = useRef(false);
  const submittedRef = useRef(false);

  const setDirty = useCallback((dirty: boolean) => {
    dirtyRef.current = dirty;
  }, []);

  const setSubmitted = useCallback(() => {
    submittedRef.current = true;
  }, []);

  const guardedClose = useCallback(() => {
    if (dirtyRef.current && !submittedRef.current) {
      if (!window.confirm('You have unsaved changes. Discard?')) return;
    }
    dirtyRef.current = false;
    submittedRef.current = false;
    onClose();
  }, [onClose]);

  const reset = useCallback(() => {
    dirtyRef.current = false;
    submittedRef.current = false;
  }, []);

  return { guardedClose, setDirty, setSubmitted, reset };
}
